import { all, AllEffect, fork, ForkEffect } from 'redux-saga/effects';
import { watchSaveCompanyTasksSaga } from './save-company-tasks';
import { watchSaveHomeResponseSaga } from './save-home-response';

export const homeRootSaga = function* (): Generator<
  AllEffect<ForkEffect<Generator<unknown, any, unknown>>>,
  void,
  unknown
> {
  yield all([fork(watchSaveCompanyTasksSaga), fork(watchSaveHomeResponseSaga)]);
};
